import { AddButton } from './AddButton'
import useWidgetList from './WidgetList'

import './styles.scss'

const App = () => {
  const widgetList = useWidgetList()

  return (
    <div
      style={{
        width: "100%",
        margin: "0 auto",
        position: "relative",
      }}
    >
      <AddButton style={{}} />
      {widgetList.el}
    </div>
  );
};

export default App;
